import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme/theme";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <ThemeProvider theme={theme}>
        <App />

    </ThemeProvider>);



// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Service worker : rend l'app disponible même sans connexion (utile
// notamment pour /timer en conditions de réseau instable). Uniquement en
// HTTPS ou localhost (contrainte des navigateurs) — échoue silencieusement
// ailleurs (ex: prévisualisation en http simple), sans bloquer l'app.
if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
        navigator.serviceWorker.register("/sw.js").catch((err) => {
            console.warn("Service worker non enregistré :", err);
        });
    });
}